import Vue from 'vue';
import { Module } from 'vuex';

import { CategorizedCoursesListState, CategorizedCoursesState, RootState } from 'frontend/types';

const categorizedCoursesByDifficulty: Module<CategorizedCoursesListState, RootState> = {
  namespaced: true,
  state: () => ({
    items: [] as CategorizedCoursesState[],
  }),
  getters: {},
  mutations: {
    setValue(state: CategorizedCoursesListState, value: CategorizedCoursesState[]): void {
      Vue.set(state, 'items', value);
    },
  },
  actions: {},
};

export default categorizedCoursesByDifficulty;
